import H from '@here/maps-api-for-javascript/bin/mapsjs.bundle.harp';
import config from '../../config';

const createPlatform = new H.service.Platform({
  apikey: config.hereMaps.apiKey,
});

const engineType = H.Map.EngineType.HARP;

export default {
  getSearchService: () => createPlatform.getSearchService(),
  createDefaultLayers: () => createPlatform.createDefaultLayers({ engineType }),
  H,
  engineType,
};
